<script>
export default {
  head: {
    title: 'Page timeout',
    meta: [
      { name: 'description', content: 'The page timed out while loading.' },
    ],
  },
}
</script>

<template>
  <div>
    <div class="content-center">
      <h1 class="title">
        Please check your internet connection or refresh the page.
      </h1>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.title {
  height: fit-content;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 106px);
}
</style>
